'use client';

interface TooltipPayloadItem {
  name: string;
  value: number;
  color: string;
}

interface ChartTooltipProps {
  active?: boolean;
  payload?: TooltipPayloadItem[];
  label?: string;
  isDark?: boolean;
}

export function ChartTooltip({ active, payload, label, isDark = true }: ChartTooltipProps) {
  if (!active || !payload?.length) return null;

  return (
    <div
      className={`rounded-[10px] border px-3.5 py-2.5 text-[13px] backdrop-blur-[10px] ${
        isDark
          ? 'border-[#2a3238] bg-[#0b0d0e]/95 text-[#e9eef2]'
          : 'border-[#E8E2D4] bg-white/95 text-[#1B2D4F]'
      }`}
    >
      <div className="mb-1 font-bold">{label}</div>
      {payload.map((p, i) => (
        <div key={i} className="text-[12px]" style={{ color: p.color }}>
          {p.name}: <strong>{p.value}</strong>
        </div>
      ))}
    </div>
  );
}
